export interface Language {
  code: string;
  name: string;
  enabled: boolean;
}

export const SUPPORTED_LANGUAGES: Language[] = [
  { code: 'en', name: 'English', enabled: true },
  { code: 'ar', name: 'Arabic', enabled: true },
  { code: 'ur', name: 'Urdu', enabled: true },
];

export const ENABLED_LANGUAGES = SUPPORTED_LANGUAGES.filter(lang => lang.enabled);

export const getLanguageByCode = (code: string): Language | undefined => {
  return SUPPORTED_LANGUAGES.find(lang => lang.code === code);
};

export const getLanguageName = (code: string): string => {
  const language = getLanguageByCode(code);
  return language?.name || code;
};

